<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
// Card "Áreas de atuação" do "Histórico de cliente".
// Extraído de HistoricoCliente.vue: mesmos agrupamentos, chips e estado vazio.
import { computed } from 'vue';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { buildOperationAreaGroups } from '../utils/leadHistoryPresenter';

const props = defineProps({
  lead: { type: Object, required: true },
});

defineEmits(['manage']);

const operationAreaGroups = computed(() =>
  buildOperationAreaGroups(props.lead)
);
const hasOperationAreas = computed(() => operationAreaGroups.value.length > 0);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Áreas de atuação">
    <template #titleAction>
      <button
        type="button"
        class="inline-flex items-center gap-2 text-[12px] font-semibold text-lais-primary hover:text-[#3d2966] underline decoration-lais-accent decoration-[1.5px] underline-offset-[3px]"
        @click="$emit('manage')"
      >
        <span class="i-lucide-map size-4" aria-hidden="true" />
        Gerenciar bairros
      </button>
    </template>
    <div v-if="hasOperationAreas" class="grid gap-3 sm:grid-cols-3">
      <section
        v-for="group in operationAreaGroups"
        :key="group.label"
        class="rounded-lais-sm border border-lais-border-soft bg-white p-4"
      >
        <p
          class="text-[11px] font-bold uppercase tracking-[0.08em] text-lais-text-muted"
        >
          {{ group.label }}
        </p>
        <div class="mt-3 flex flex-wrap gap-2">
          <span
            v-for="value in group.values"
            :key="`${group.label}-${value}`"
            class="rounded-full bg-lais-primary-50 px-2.5 py-1 text-[12px] font-semibold text-lais-primary"
          >
            {{ value }}
          </span>
        </div>
      </section>
    </div>
    <div
      v-else
      class="rounded-lais-sm border border-dashed border-lais-border bg-lais-bg-soft p-5 text-center"
    >
      <span
        class="i-lucide-map-pinned mx-auto size-8 text-lais-icon"
        aria-hidden="true"
      />
      <p class="mt-3 text-[14px] font-semibold text-lais-text">
        Não há cidades cadastradas para a sua imobiliária
      </p>
      <p class="mx-auto mt-1 max-w-[420px] text-[13px] text-lais-text-body">
        Entre em contato com o nosso suporte para realizar esse cadastro
      </p>
    </div>
  </LaisCard>
</template>
